var _path, _line, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouthCardsManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.9609 9.7915H8.65497C7.22481 9.7915 6.06543 11.027 6.06543 12.551V29.108C6.06543 30.6321 7.22481 31.8676 8.65497 31.8676H31.9609C33.391 31.8676 34.5504 30.6321 34.5504 29.108V12.551C34.5504 11.027 33.391 9.7915 31.9609 9.7915Z",
    fill: "url(#paint0_linear_4820_1648)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.85217,
    y1: 17.4912,
    x2: 34.5504,
    y2: 17.4912,
    stroke: "url(#paint1_linear_4820_1648)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.63025,
    y: 9.39111,
    width: 30.2,
    height: 22.75,
    rx: 4.5,
    stroke: "url(#paint2_linear_4820_1648)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5417,
    y: 26.7434,
    width: 6,
    height: 2,
    rx: 1,
    fill: "url(#paint3_linear_4820_1648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4820_1648",
    x1: 6.06543,
    y1: 20.8295,
    x2: 34.5504,
    y2: 20.8295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4820_1648",
    x1: 4.85217,
    y1: 18.4912,
    x2: 34.5504,
    y2: 18.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4820_1648",
    x1: 4.13025,
    y1: 20.7661,
    x2: 35.3302,
    y2: 20.7661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4820_1648",
    x1: 25.5417,
    y1: 27.7434,
    x2: 31.5417,
    y2: 27.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouthCardsManagement);
export default __webpack_public_path__ + "static/media/youthCardsManagement.5024b9b22e62cd502fa541bba92bbc6a.svg";
export { ForwardRef as ReactComponent };